import { useSnackbar } from 'notistack';
import React, { FC } from 'react';

import providerLabel from '~/pages/auth/shared/utils/providerLabel';
import { useAuth } from '~/shared/contexts/AuthContext';
import {
  authenticateWithProvider,
  IdentityProvider,
  ProviderCredential,
  signIn,
} from '~/shared/services/userService';
import { parseErrorMessages } from '~/shared/utils/errorMessages';

import SignIn, { FormShape } from '../components/SignIn';

const PageContainer: FC = () => {
  const { enqueueSnackbar } = useSnackbar();
  const { setOAuthData } = useAuth();

  const handleSignIn = async (values: FormShape) => {
    try {
      const data = await signIn(values.email, values.password);
      setOAuthData(data);
    } catch (error) {
      enqueueSnackbar(parseErrorMessages(error), { variant: 'error' });
      throw error;
    }
  };

  const handleProviderCredential = async (
    provider: IdentityProvider,
    credential: ProviderCredential
  ) => {
    try {
      const { oAuthData } = await authenticateWithProvider(
        provider,
        credential
      );
      setOAuthData(oAuthData);
    } catch (error: any) {
      const message =
        error?.response?.status === 404
          ? `No account found for this ${providerLabel(
              provider
            )} account. Please sign up first.`
          : parseErrorMessages(error);
      enqueueSnackbar(message, { variant: 'error' });
    }
  };

  const handleProviderError = (provider: IdentityProvider) => {
    enqueueSnackbar(
      `${providerLabel(
        provider
      )} sign-in was cancelled or failed. Please try again.`,
      { variant: 'error' }
    );
  };

  return (
    <SignIn
      onSubmit={handleSignIn}
      onProviderCredential={handleProviderCredential}
      onProviderError={handleProviderError}
    />
  );
};

export default PageContainer;
